module.exports = __webpack_public_path__ + "img/pic_zb_d2.d34f9828.png";